module.exports = __webpack_public_path__ + "assets/img/thumb-National-Media-Social-Static-Ad.cbd50a0b.jpg";